import { Box, Typography, useTheme } from '@mui/material';
import { Thumbnail } from '@/components/Thumbnail';
import { Asset } from '@/api/generatedApi';
import { pluralize } from '@/utils/format';

const MAX_THUMBNAILS = 3;
const STACK_OFFSET = 6;

export const DragPreview = ({ count, assets }: { count: number; assets: Asset[] }) => {
  const displayAssets = assets.slice(0, MAX_THUMBNAILS);
  const thumbnailSize = 48;
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        background: `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.25)',
        paddingTop: '14px',
        cursor: 'grabbing',
        minWidth: '100px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          width: `${thumbnailSize}px`,
          height: `${thumbnailSize}px`,
        }}
      >
        {displayAssets.map((asset, index) => {
          const centerOffset = ((displayAssets.length - 1) * STACK_OFFSET) / 2;
          return (
            <Box
              key={asset.id}
              sx={{
                position: 'absolute',
                transform: `translate(${index * STACK_OFFSET - centerOffset}px, ${index * STACK_OFFSET - centerOffset}px)`,
                zIndex: MAX_THUMBNAILS - index,
                borderRadius: '6px',
                overflow: 'hidden',
                border: `2px solid ${theme.palette.background.paper}`,
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                background: theme.palette.background.paper,
              }}
            >
              <Thumbnail size={thumbnailSize} asset={asset} noLink={true} />
            </Box>
          );
        })}
      </Box>
      <Typography
        sx={{
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          fontSize: '13px',
          fontWeight: 600,
          color: 'common.white',
          textAlign: 'center',
          whiteSpace: 'nowrap',
        }}
      >
        {pluralize(count, 'asset', 'assets')}
      </Typography>
    </Box>
  );
};
